<template>
  <div>
    <div class="pageTitleController">
      <img src="@/assets/img/7.png" />
      <div class="marginLeft15">企业信息</div>
    </div>
    <!--下面是显示详情-->
    <div class="marginTop20">
      <Accordion :title="`${infoForm.company_name}-资料详情`" :show="true">
        <div class="componyInfoMainController">
          <!--审核中-->
          <div v-if="info && info.profile_step === 4">
            <!--审核状态-->
            <div class="shenheInfoController">
              <div class="shenheTitle">
                审核信息
              </div>
              <div class="shenheInfo">
                <img class="statusInfo" src="@/assets/img/lan.png" />
                <div class="shenheCon">
                  <div class="shenheTi">
                    您的资料正在审核中，请耐心等待
                  </div>
                  <div class="shenheDes">
                    如有疑问请联系
                    <span class="tel">
                      0871-68183040 15887247294
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <!--审核状态-->
            <div class="shenhezhaungtai marginTop20">
              <div class="zhaungtaiTitle">审核状态</div>
              <div class="zhaungtaiInfo tel">审核中</div>
            </div>
          </div>
          <!--审核成功-->
          <div v-if="info && info.profile_step === 2">
            <!--审核状态-->
            <div class="shenheInfoController">
              <div class="shenheTitle">
                审核信息
              </div>
              <div class="shenheInfo">
                <img class="statusInfo" src="@/assets/img/gou.png" />
                <div class="shenheCon">
                  <div class="shenheTi">
                    恭喜
                  </div>
                  <div class="shenheDes">
                    您的资料已通过审核
                  </div>
                </div>
              </div>
            </div>
            <!--审核状态-->
            <div class="shenhezhaungtai marginTop20">
              <div class="zhaungtaiTitle">审核状态</div>
              <div style="color:#00a405;" class="zhaungtaiInfo tel">
                审核通过
              </div>
            </div>
          </div>
          <!--审核失败-->
          <div v-if="info && info.profile_step === 3">
            <!--审核状态-->
            <div class="shenheInfoController">
              <div class="shenheTitle">
                审核信息
              </div>
              <div class="shenheInfo">
                <img class="statusInfo" src="@/assets/img/cha.png" />
                <div class="shenheCon">
                  <div class="shenheTi">
                    抱歉您的资料未通过初审，请求改后重新提交
                  </div>
                  <div class="shenheDes">
                    {{ info.checkmark }}
                  </div>
                </div>
              </div>
            </div>
            <!--审核状态-->
            <div class="shenhezhaungtai marginTop20">
              <div class="zhaungtaiTitle">审核状态</div>
              <div style="color:#ed4014;" class="zhaungtaiInfo tel">
                返回修改
              </div>
            </div>
          </div>

          <!--第一个区域-->
          <div class="componyInfoController marginTop20">
            <div class="aCompony">
              <div class="titles">企业名称</div>
              <div class="des marginTop20">{{ infoForm.company_name }}</div>
            </div>
            <div class="aCompony">
              <div class="titles">企业类型</div>
              <div class="des marginTop20">
                {{ showComponytype }}
              </div>
            </div>
            <div class="aCompony">
              <div class="titles">统一社会信用代码</div>
              <div class="des marginTop20">{{ infoForm.social_code }}</div>
            </div>
            <div class="aCompony">
              <div class="titles">注册资金（万元）</div>
              <div class="des marginTop20">{{ infoForm.reg_capital }}</div>
            </div>
            <div class="aCompony">
              <div class="titles">法定代表人</div>
              <div class="des marginTop20">{{ infoForm.legal_name }}</div>
            </div>
            <div class="aCompony">
              <div class="titles">法定代表人联系电话</div>
              <div class="des marginTop20">{{ infoForm.legal_tel }}</div>
            </div>
            <div class="aCompony">
              <div class="titles">企业注册地址</div>
              <div class="des marginTop20">
                <div class="flexAre">
                  <Areselect :onlyshow="true" v-model="areCodeList"></Areselect>
                  {{ infoForm.register_address }}
                </div>
              </div>
            </div>
            <div v-if="yinyezhizhao[0]" class="aCompony">
              <div class="titles">营业执照（彩色扫描件）</div>
              <div class="des marginTop20">
                <a
                  :href="yinyezhizhao[0].viewurl"
                  target="_blank"
                  style="color:#00B1FF;"
                >
                  营业执照（彩色扫描件）.JPG
                </a>
              </div>
            </div>
          </div>
          <div class="lines"></div>
          <!--第二个区域-->
          <div class="componyInfoController">
            <div class="aCompony">
              <div class="titles">经办人</div>
              <div class="des marginTop20">{{ infoForm.contact_person }}</div>
            </div>
            <div class="aCompony">
              <div class="titles">经办人电话</div>
              <div class="des marginTop20">{{ infoForm.contact_tel }}</div>
            </div>
            <div class="aCompony">
              <div class="titles">通信地址</div>
              <div class="des marginTop20">{{ infoForm.contact_address }}</div>
            </div>
          </div>
        </div>
      </Accordion>
      <div class="btnController marginTop20" style="text-align: center;">
        <div class="yuanLouKongBtn" @click="$router.go(-1)">返回</div>
      </div>
    </div>
  </div>
</template>

<script>
import Api from "@/plugins/axios.js";
import Accordion from "@/components/Accordion.vue";
import Areselect from "@/components/Areselect.vue";
import { Loading } from "element-ui";
// import Accordion from "@/components/Accordion.vue";
export default {
  components: {
    Accordion,
    Areselect
  },
  data() {
    return {
      type: null, // 判断生产商资料还是其他的什么
      uuid: null, // 生产商资料修改模式下面的 UUID
      save: false, // 是否是修改模式
      fenlei: [], // 企业信息分类
      info: null, // 全部详细信息
      // 显示企业类型
      showComponytype: null,
      // 三级地址下拉
      areCodeList: [],
      profile_step: null, // 是否是从生产商添加那个列表页跳过来的
      // 提交的表单信息
      infoForm: {
        company_name: "", // 企业名称
        company_cate: "", // 企业分类
        social_code: "", // 统一社会信用代码
        reg_capital: "", // 注册资本
        legal_name: "", // 法定代表人
        legal_tel: "", // 电话
        register_address: "", // 注册地址
        contact_person: "", // 联系人
        contact_tel: "", // 联系人电话
        contact_address: "" // 联系地址
      },
      yinyezhizhao: [], // 营业执照
      weituoshu: [], // 委托书
      back: 0 // 是否是返回1是返回上一步
    };
  },
  mounted() {
    // 判断是否是返回
    if (this.$route.query.back) {
      this.back = 1;
    }
    // 是否是从生产商添加那个列表页跳过来的
    if (this.$route.query.profile_step) {
      this.profile_step = 5;
    }
    console.log("来源模式", this.infoForm.profile_step);
    // 传递模式
    if (this.$route.query.type) {
      this.type = this.$route.query.type;
      this.save = true;
    }
    // 传递修改uuid
    if (this.$route.query.uuid) {
      this.uuid = this.$route.query.uuid;
    }
    // 判断是自身的修改模式还是怎么说
    this.getFlList();
    this.init();
  },
  watch: {
    $route() {
      // 传递模式
      if (this.$route.query.type) {
        this.type = this.$route.query.type;
        this.save = true;
      } else {
        this.type = null;
        this.save = false;
      }
      // 传递修改uuid
      if (this.$route.query.uuid) {
        this.uuid = this.$route.query.uuid;
      } else {
        this.uuid = null;
      }
      // 判断是自身的修改模式还是怎么说
      this.getFlList();
      this.init();
    }
  },
  methods: {
    // 获得企业分类
    async getFlList() {
      const li = await Api.getQyFl("business_class", 1);
      this.fenlei = li;
    },
    // 初始化查询
    async init() {
      const loadingInstance = Loading.service({ fullscreen: true });
      // 企业信息获得
      let info = null;
      if (this.type === null) {
        // 获得自己的信息
        info = await Api.userinfo(this.$store.state.token);
      } else if (this.uuid !== null) {
        info = await Api.getAgent(this.$store.state.token, this.uuid);
      }
      if (info) {
        this.info = info;
      }

      // 判断当前资料能否修改
      if (!(info !== null && info.profile_step !== 1)) {
        this.save = true;
        console.log("修改保存模式");
      }

      // 处理三级下拉选择器
      if (info) {
        let arr = [];
        if (info.province_code) {
          arr[0] = info.province_code;
        }
        if (info.city_code) {
          arr[1] = info.city_code;
        }
        if (info.area_code) {
          arr[2] = info.area_code;
        }
        this.areCodeList = arr;
        console.log("三级下拉", this.areCodeList);
      } else {
        this.areCodeList = [];
      }

      // 计算显示用的企业类型
      if (info) {
        for (let index = 0; index < this.fenlei.length; index++) {
          const element = this.fenlei[index];
          // console.log(parseInt(info.company_cate), parseInt(element.id));
          if (parseInt(info.company_cate) === parseInt(element.id)) {
            console.log(element);
            this.showComponytype = element.name;
          }
        }
        console.log("显示的企业类型", this.showComponytype);
      }

      this.infoForm = {
        company_name: info ? info.company_name : "", // 企业名称
        company_cate: info ? info.company_cate : "", // 企业分类
        social_code: info ? info.social_code : "", // 统一社会信用代码
        reg_capital: info ? info.reg_capital : "", // 注册资本
        legal_name: info ? info.legal_name : "", // 法定代表人
        legal_tel: info ? info.legal_tel : "", // 电话
        register_address: info ? info.register_address : "", // 注册地址
        contact_person: info ? info.contact_person : "", // 联系人
        contact_tel: info ? info.contact_tel : "", // 联系人电话
        contact_address: info ? info.contact_address : "" // 联系地址
      };
      if (info && info.business_license) {
        this.yinyezhizhao = [
          {
            name: "",
            url: info.business_license,
            viewurl: Api.domain + info.business_license
          }
        ];
      } else {
        this.yinyezhizhao = [];
      }
      if (info && info.agent_attorney) {
        this.weituoshu = [
          {
            name: "",
            url: info.agent_attorney,
            viewurl: Api.domain + info.agent_attorney
          }
        ];
      } else {
        this.weituoshu = [];
      }
      loadingInstance.close();
    },
    // 提交信息
    async sub(action) {
      if (this.areCodeList.length !== 3) {
        this.$msgbox({
          title: "提示",
          type: "error",
          message: "请选择企业注册地址"
        });
        return false;
      }
      let sendData = {
        profile_step: this.profile_step,
        province_code: this.areCodeList[0], // 省
        city_code: this.areCodeList[1], // 城市
        area_code: this.areCodeList[2], // 区域
        action,
        ...this.infoForm,
        business_license:
          this.yinyezhizhao.length === 1 ? this.yinyezhizhao[0].url : "",
        agent_attorney: this.weituoshu.length === 1 ? this.weituoshu[0].url : ""
      };

      // 判断是不是修改
      if (this.uuid) {
        sendData.id = this.uuid;
      }

      const loadingInstance = Loading.service({ fullscreen: true });
      try {
        Loading.service({ fullscreen: true });
        // 判断是不是生产厂商添加
        let agent = false;
        if (this.type !== null) {
          agent = true;
        }
        await Api.saveProfile(this.$store.state.token, sendData, agent);
        this.$msgbox({ title: "提示", type: "success", message: "操作成功" });

        if (!agent) {
          // 重新加载数据
          this.init();
          this.save = false;
        } else {
          if (this.infoForm.profile_step === 5 || this.back === 1) {
            this.$msgbox({
              title: "提示",
              type: "success",
              message: "操作成功"
            });
            this.$router.go(-1);
          } else {
            // 跳转回到列表页
            this.$router.push({
              name: "InfoList"
            });
          }
        }
      } catch (error) {
        this.$msgbox({ title: "提示", type: "error", message: error });
      }
      loadingInstance.close();
    }
  }
};
</script>
<style lang="less" scoped>
.flexTextCenter {
  text-align: center;
}
// 上传
.upShowController {
  position: relative;
  right: 0px;
  top: 0px;
  .del {
    position: absolute;
    top: 0px;
    right: 0px;
    color: red;
    font-size: 22px;
  }
}
.flexAre {
  display: flex;
  align-items: center;
}
// 企业信息显示详情
.componyInfoMainController {
  // 审核详情
  .shenheInfoController {
    .shenheTitle {
      padding: 16px 32px;
      font-size: 16px;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      opacity: 1;
    }
    // 详情容器
    .shenheInfo {
      border-top: 1px solid rgba(230, 230, 230, 1);
      padding: 24px 32px;
      display: flex;
      .shenheCon {
        margin-left: 20px;
        .shenheTi {
          font-size: 12px;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          opacity: 1;
        }
        .shenheDes {
          margin-top: 5px;
          font-size: 12px;
          font-weight: 400;
          color: #999999;
          opacity: 1;
        }
      }
    }
  }
  // 审核状态
  .shenhezhaungtai {
    padding: 12px 32px;
    display: flex;
    // 状态标题
    .zhaungtaiTitle {
      font-size: 14px;
      font-weight: 400;
      color: rgba(153, 153, 153, 1);
      opacity: 1;
    }
    // 状态详情
    .zhaungtaiInfo {
      margin-left: 30px;
      font-size: 14px;
      font-weight: 400;
      opacity: 1;
    }
  }
  // 蓝色
  .tel {
    color: #00b1ff;
  }
  .shenheInfoController,
  .shenhezhaungtai {
    background-color: #f0f5f7;
    border-radius: 10px;
  }
  // 企业信息显示详情
  .componyInfoController {
    display: flex;
    flex-wrap: wrap;
    .aCompony {
      width: 33%;
      min-width: 33%;
      margin-top: 35px;
      // 标题
      .titles {
        font-size: 12px;
        font-weight: 400;
        color: rgba(153, 153, 153, 1);
        opacity: 1;
      }
      // 描述
      .des {
        font-size: 12px;
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
        opacity: 1;
        a {
          text-decoration: none;
          color: #00b1ff;
        }
      }
    }
    .aCompony:nth-child(1),
    .aCompony:nth-child(2),
    .aCompony:nth-child(3) {
      margin-top: 0px;
    }
  }
  .btnController {
    text-align: center;
  }
}
</style>
